import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default function LiveRegion({ title }) {
	const [status, setStatus] = useState('active');

	useEffect(() => {
		const statusTimeout = setTimeout(() => setStatus('inactive'), 2000);
		return () => {
			clearTimeout(statusTimeout);
		};
	}, []);

	return status === 'active'
		? ReactDOM.createPortal(
				<span role="status" aria-live="polite" className="visually-hidden">
					navigated to {title}
				</span>,
				document.body
		  )
		: null;
}

LiveRegion.propTypes = {
	title: PropTypes.string
};
